// Copyright (c) Move Closer 2022.

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export const PROFILE_WRAPPER_COMPONENT_KEY = 'ProfileWrapperComponent'

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export interface ProfileWrapperComponentConfig {
  containerClass: string[]
  containerListClass: string[]
  hasWelcomeHeading: boolean
  hasTabs: boolean
  shouldCenterNavigationElements: boolean
  navListContainerClasses: string[]
}

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export const PROFILE_WRAPPER_COMPONENT_CONFIG_MAP: ProfileWrapperComponentConfig = {
  // todo: lirene: w lirene chyba puste?
  containerClass: ['container-medium'],
  containerListClass: ['container-medium'],
  hasWelcomeHeading: true,
  hasTabs: true,
  navListContainerClasses: [],
  shouldCenterNavigationElements: false
}

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export const PROFILE_NAV_TAB_LIST_ELEMENT = '.profile-nav-tabs__navigation ul'
export const PROFILE_NAV_TAB_ACTIVE_ELEMENT_CLASS = 'router-link-exact-active'
